import { toast } from "sonner";
import { Copy, ExternalLink, Link2 } from "lucide-react";

export function ExternalLinkRow({ url, gid }) {
  const copy = async () => { await navigator.clipboard.writeText(url); toast.success("Link copied"); };
  return (
    <div className="mt-5 flex flex-wrap items-center gap-3 border border-border p-4">
      <Link2 className="h-4 w-4 text-slate-400 shrink-0" strokeWidth={1.5} />
      <a href={url} target="_blank" rel="noreferrer" data-testid={`ext-link-${gid}`} className="text-sm truncate flex-1 min-w-[200px] hover:underline underline-offset-4">{url}</a>
      <button data-testid={`ext-copy-${gid}`} onClick={copy} className="inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-[0.12em] border border-slate-300 px-3 h-9 hover:border-slate-900"><Copy className="h-3.5 w-3.5" /> Copy</button>
      <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-[0.12em] bg-slate-900 text-slate-50 px-3 h-9"><ExternalLink className="h-3.5 w-3.5" /> Open</a>
    </div>
  );
}
